module.exports = __webpack_public_path__ + "img/anevil_front_2.f05edc11.png";